import { observable, computed, action } from 'mobx'
import moment from 'moment'
import BaseQueryParamsStore from 'shared/stores/BaseQueryParamsStore'

import { MIN_DATE, MAX_DATE, TRANSPORT_DATE_FORMAT } from 'shared/config/widget'

import lightTheme from 'shared/themes/light'
import darkTheme from 'shared/themes/dark'

export const THEME = {
  LIGHT: 'light',
  DARK: 'dark',
}

export const CODE_TYPE = {
  TNVED: 'tnved',
  //GNG: 'gng',
  //ETSNG: 'etsng'
}

export const SHOW_TITLE = {
  TRUE: 'true',
  FALSE: 'false',
}

export const COLLAPSED = {
  TRUE: 'true',
  FALSE: 'false',
}

export const DEFAULT_CODE = null

export const DIRECTION_CUSTOMS = {
  COMMON: '0',
  EXPORT: '1',
  IMPORT: '2',
}

export const CLEARANCE_COUNTRIES = {
  ALL: 'Все страны',
  RU: 'Россия',
  BY: 'Беларусь',
  KZ: 'Казахстан',
  AM: 'Армения',
  KG: 'Киргизия',
}

const DEFAULT_QUERY_PARAMS = {
  apiKey: null,
  theme: THEME.LIGHT,
  type: CODE_TYPE.TNVED,
  date: null,
  direction: DIRECTION_CUSTOMS.IMPORT,
  clearanceCountry: 'RU',
  originCountry: 'ALL',
  code: DEFAULT_CODE,
  showTitle: SHOW_TITLE.TRUE,
  collapsed: COLLAPSED.FALSE,
  dominantMode: false,
  treeLink: null,
  treeLinkTarget: null,
}

export default class QueryParamsStore extends BaseQueryParamsStore {
  DEFAULT_QUERY_PARAMS = DEFAULT_QUERY_PARAMS

  @observable queryParams = {}

  @computed
  get apiKey() {
    return this.queryParams.apiKey
  }

  @computed
  get code() {
    return this.queryParams.code
  }

  @computed
  get dominantMode() {
    return this.queryParams.dominantMode === 'true'
  }

  @computed
  get treeLink() {
    return this.queryParams.treeLink
  }

  @computed
  get treeLinkTarget() {
    return this.queryParams.treeLinkTarget
  }

  @computed
  get theme() {
    let theme = lightTheme

    if (this.queryParams.theme === THEME.DARK) {
      theme = darkTheme
    }

    return theme
  }

  @computed
  get dataStore() {
    const { type } = this.queryParams
    const { tnvedCodeStore, gngCodeStore, etsngCodeStore } = this.rootStore
    let result

    // temporary stub to return TnvedCodeStore by default. Remove when Etsng and GNG are enabled
    if (!type) return tnvedCodeStore

    switch (type) {
      case CODE_TYPE.TNVED:
        result = tnvedCodeStore
        break
      case CODE_TYPE.ETSNG:
        result = etsngCodeStore
        break
      case CODE_TYPE.GNG:
        result = gngCodeStore
        break
      default:
        throw new Error('Invalid Code Type')
    }

    return result
  }

  @computed
  get date() {
    const { date } = this.queryParams
    return date ? moment(date, TRANSPORT_DATE_FORMAT) : null
  }
  set date(value) {
    this.queryParams.date = value ? value.format(TRANSPORT_DATE_FORMAT) : null
    this.updateUrl()
  }

  @computed
  get direction() {
    return this.queryParams.direction
  }
  set direction(value) {
    this.queryParams.direction = value
    this.updateUrl()
  }

  @computed
  get clearanceCountry() {
    return this.queryParams.clearanceCountry
  }
  set clearanceCountry(value) {
    this.queryParams.clearanceCountry = value
  }

  @computed
  get originCountry() {
    return this.queryParams.originCountry;
  }
  set originCountry(value) {
    this.queryParams.originCountry = value;
  }

  @computed
  get showTitle() {
    return this.queryParams.showTitle === SHOW_TITLE.TRUE
  }

  @computed
  get collapsed() {
    return this.queryParams.collapsed === COLLAPSED.TRUE
  }

  constructor() {
    super(...arguments)
    this.queryParams = DEFAULT_QUERY_PARAMS
    this.extractQueryParams()
  }

  @action.bound
  extractQueryParams() {
    const queryParams = super.extractQueryParams()
    this.extractRawParam(queryParams, 'apiKey', null)
    this.extractRawParam(queryParams, 'code', DEFAULT_CODE)
    this.extractDictionaryParam(queryParams, 'theme', THEME)
    this.extractDictionaryParam(queryParams, 'type', CODE_TYPE)
    this.extractDateParam(
      queryParams,
      'date',
      TRANSPORT_DATE_FORMAT,
      MIN_DATE,
      MAX_DATE,
    )
    this.extractRawParam(
      queryParams,
      'direction',
      this.direction === undefined ? DIRECTION_CUSTOMS.IMPORT : this.direction,
    )
    this.extractRawParam(
      queryParams,
      'clearanceCountry',
      this.clearanceCountry === undefined ? 'RU' : this.clearanceCountry,
    )
    this.extractRawParam(queryParams, 'originCountry', this.originCountry === undefined ? 'ALL' : this.originCountry);
    this.extractDictionaryParam(queryParams, 'showTitle', SHOW_TITLE)
    this.extractDictionaryParam(queryParams, 'collapsed', COLLAPSED)
    this.extractRawParam(queryParams, 'dominantMode', false)
    this.extractRawParam(queryParams, 'treeLink', null)
    this.extractRawParam(queryParams, 'treeLinkTarget', null)
  }
}



// WEBPACK FOOTER //
// ./src/stores/QueryParamsStore.js